<div class="gauge-component" [ngStyle]="{ color: color }">
  <span class="middle-marker"></span>
  <span class="ending-marker"></span>
  <ngx-gauge
    class="chart"
    type="semi"
    thick="20"
    size="200"
    [foregroundColor]="color"
    [value]="value"
    [max]="100"
    [min]="0"
    append="%"
  ></ngx-gauge>
</div>
